import { IconButton, Menu, alpha, styled } from '@mui/material';

export const NotificationIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  borderRadius: '14px',
  transition: 'background-color 120ms ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
  },
}));

export const NotificationWrapper = styled('div')({
  position: 'relative',
  display: 'inline-flex',
});

export const SearchInput = styled('input')(({ theme }) => ({
  width: '100%',
  padding: '8px 12px 8px 34px',
  fontSize: '13px',
  color: theme.palette.text.primary,
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  borderRadius: '14px',
  outline: 'none',
  transition: 'border-color 120ms ease, background-color 120ms ease',
  '&:focus': {
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.primary.main,
  },
  '&::placeholder': {
    color: theme.palette.text.secondary,
  },
}));

export const SearchWrapper = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  margin: '10px 12px 0',
});

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '10px',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  pointerEvents: 'none',
}));

export const FilterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '2px',
  margin: '10px 12px',
  padding: '3px',
  backgroundColor: alpha(theme.palette.text.primary, 0.06),
  borderRadius: '10px',
}));

export const FilterButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  flex: 1,
  border: 'none',
  borderRadius: '8px',
  padding: '6px 12px',
  fontSize: '13px',
  fontWeight: active ? 600 : 400,
  color: active ? theme.palette.text.primary : theme.palette.text.secondary,
  backgroundColor: active ? theme.palette.background.paper : 'transparent',
  cursor: 'pointer',
  transition: 'background-color 150ms ease, color 150ms ease, box-shadow 150ms ease',
  boxShadow: active ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const NoResults = styled('div')(({ theme }) => ({
  padding: '24px 16px',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '13px',
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    width: '22rem',
    maxHeight: '80%',
    marginTop: '8px',
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));
